import { RedirectLoginOptions } from '@auth0/auth0-react/dist/auth0-context';

export const loginConfig = (returnTo: string): RedirectLoginOptions => {
  return {
    appState: { returnTo },
    authorizationParams: {
      scope: 'openid profile email offline_access read:current_user',
    },
  };
};
